export enum GasRequestStatusEnum {
  APPRVD = 'APPRVD'
}
